import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const FACT_LABELS = {
  NDR_REMARK: 'NDR Remark',
  NPR_REMARK: 'NPR Remark',
  PAYMENT_MODE: 'Payment Mode',
  OFD_COUNT: 'OFD Count',
  OFP_COUNT: 'OFP Count',
  COURIER_PARENT_NAME: 'Courier',
  COURIER_PROZO_ID: 'Courier ID',
  PREFERRED_DELIVERY_DATE: 'Reattempt Days',
  PREFERRED_PICKUP_DATE: 'Reattempt Days',
  DAYS_SINCE_FIRST_ATTEMPT: 'Days Since First Attempt',
}

export default function RuleViewer({ rule, index }) {
  if (!rule) return null

  const conditions = rule.conditions || []
  const result = rule.result || {}
  const actionType = result.action || result.ndrAction || result.nprAction || '—'
  const isReattempt = actionType.toUpperCase().includes('REATTEMPT')

  return (
    <Box className='rule-card'>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant='caption' sx={{ fontWeight: 700, color: 'text.secondary' }}>
          Rule {index != null ? `#${index + 1}` : ''}{rule.name ? `: ${rule.name}` : ''}
        </Typography>
        <span className={`action-badge ${isReattempt ? 'reattempt' : 'rto'}`}>
          {actionType}
          {result.preferredDeliveryDate && ` (+${result.preferredDeliveryDate}d)`}
        </span>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <Typography variant='caption' sx={{ fontWeight: 700, color: '#0F4C81', minWidth: 20, mt: '2px' }}>IF</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {conditions.map((c, i) => (
            <span key={i} className='condition-chip'>
              {FACT_LABELS[c.fact] || c.fact} {c.operator} {Array.isArray(c.value) ? c.value.join(', ') : c.value}
            </span>
          ))}
          {!conditions.length && (
            <Typography variant='caption' sx={{ color: 'text.disabled' }}>(no conditions)</Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}
